/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Stack, InputLabel, FormHelperText, Typography } from '@mui/material';
import Counter from '../../../components/Counter';

export const SeedCounter = ({
  errorMessage,
  label,
  onChange,
  testId,
  unit,
  value,
  type,
  disabled,
}: {
  disabled?: boolean;
  errorMessage?: string;
  label: string;
  onChange: (input: number) => void;
  testId?: string;
  unit?: string;
  value: number;
  type?: 'number' | 'decimal';
}) => (
  <Stack>
    <InputLabel htmlFor={testId}>{label}</InputLabel>
    <Stack direction='row' alignItems='center' spacing={1}>
      <Counter
        disabled={disabled}
        type={type}
        value={value}
        onChange={(value) => {
          onChange(value);
        }}
      />
      {unit ? <Typography variant='body2'>{unit}</Typography> : null}
    </Stack>
    {errorMessage ? (
      <FormHelperText id={`${testId}-helper-text`} data-testid={`${testId}-helper-text`}>
        {errorMessage ?? ' '}
      </FormHelperText>
    ) : null}
  </Stack>
);
